import(/* webpackMode: "eager", webpackExports: ["Reveal"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\motion-primitives.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaSection"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\sections\\cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\node_modules\\lucide-react\\dist\\esm\\Icon.mjs");
;
import(/* webpackMode: "eager" */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\node_modules\\next\\dist\\client\\image-component.js");
